module.exports = __webpack_public_path__ + "img/nekhl.25990cee.jpg";